// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

interface CollapseArrowProps {
  open: boolean;
}

// The arrow for every section fold (AUT-6669): > while folded, v while open, as in the 2D viewer
// and Project Viewer sidebars. Drawers that slide away keep arrows pointing the way they move.
export const CollapseArrow = ({ open }: CollapseArrowProps) => (
  open ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />
);

export default CollapseArrow;
